module.exports = __webpack_public_path__ + "static/logo_longines-c0cfe0491702f1ab8d89a2463b981894.svg";